import { shimmerAnimationNames } from '#pplx/frontend/aether/primitives/ShimmerPrimitive/animationNames.js';
import { useCallback, useEffect, useState } from 'react';
/**
 * Unscoped keyframe names from the legacy global shimmer stylesheets, which are
 * still loaded by callsites that have not moved to ShimmerPrimitive yet.
 */
const LEGACY_SHIMMER_ANIMATION_NAMES = ['shine', 'shimmer-text-sweep'];
const COMPLETION_ANIMATION_NAMES = new Set([
    ...shimmerAnimationNames,
    ...LEGACY_SHIMMER_ANIMATION_NAMES,
]);
export function useFiniteShimmer({ showShimmer, shimmerKey, onComplete, shouldPauseInBackground = false, }) {
    const [shimmerFinished, setShimmerFinished] = useState(false);
    const [documentHidden, setDocumentHidden] = useState(false);
    useEffect(() => {
        setShimmerFinished(false);
    }, [shimmerKey]);
    useEffect(() => {
        if (!shouldPauseInBackground || !showShimmer || shimmerFinished)
            return;
        setDocumentHidden(document.hidden);
        const handler = () => setDocumentHidden(document.hidden);
        document.addEventListener('visibilitychange', handler);
        return () => document.removeEventListener('visibilitychange', handler);
    }, [shouldPauseInBackground, showShimmer, shimmerFinished]);
    const shimmerActive = !!showShimmer && !shimmerFinished;
    const onAnimationEnd = useCallback((e) => {
        if (COMPLETION_ANIMATION_NAMES.has(e.animationName)) {
            setShimmerFinished(true);
            onComplete?.();
        }
    }, [onComplete]);
    return { shimmerActive, paused: documentHidden, onAnimationEnd };
}
//# sourceMappingURL=useFiniteShimmer.js.map